export const ru = {
    header: {
        feedback: 'Обратная связь',
        singIn: 'Вход',
        logOut: 'Выход',
        menuMain: 'Главная',
        menuDemotests: 'Демо-тесты',
        menuStatistics: 'Статистика',
        personalAccount: 'Личный кабинет',
        about:'О платформе',
    },
    mainpage:{
        upperText: 'НАЦИОНАЛЬНОЕ ИССЛЕДОВАНИЕ КАЧЕСТВА ОБРАЗОВАНИЯ (НИКО)',
        lowerText1: 'НИКО включает:',
        lowerText2: '- выполнение обучающимися тестовых заданий для установления уровня функциональной грамотности;',
        lowerText3: '- анкетирование обучающихся;',
        lowerText4: '- анкетирование законных представителей обучающихся;',
        lowerText5: '- анкетирование педагогов учреждений образования;',
        lowerText6: '- анкетирование администрации учреждений образования.',
        lowerTextButton: 'Демо-тест',
        lastText: '2022 ГИАЦ Минобразования',
        more:'Информация',
        },
    about:{
        centralText: ' Национальное исследование качества образования (НИКО) – программа оценки функциональной грамотности обучающихся, имеющих общее базовое образование. НИКО  измеряет способность молодых людей, находящихся на этапе профессионального выбора, применять знания, умения и навыки для решения жизненных задач. ',
        instruction:'Инструкция (.dox)',
        forTeacher:'Для организаторов НИКО в учереждениях образования',
        forStudent:'Для обучающихся',
        forCurator:'Для координаторов',
        forExpert:'Для экспертов',
        card1:'Читательская грамотность',
        card1Text:'способность человека понимать, использовать, оценивать тексты, размышлять о них и заниматься чтением, чтобы достигать своих целей, расширять свои знания и участвовать в социальной жизни.',
        card2:'Естественно-научная грамотность',
        card2Text:'это способность человека занимать активную гражданскую позицию по общественно значимым вопросам, связанным с естественными науками, и его готовность интересоваться естественнонаучными идеями.',
        card3:'Математическая грамотность',
        card3Text:'это способность человека мыслить математически, формулировать, применять и интерпретировать математику для решения задач в разнообразных практических контекстах. Она включает в себя понятия, процедуры и факты, а также инструменты для описания, объяснения и предсказания явлений.',
        card4:'Финансовая грамотность',
        card4Text:'сочетание осведомленности, знаний, навыков, установок и поведения, связанных с финансами и необходимых для принятия разумных финансовых решений, а также достижения личного финансового благополучия; набор компетенций человека, которые образуют основу для разумного принятия финансовых решений.',
    },
    feedback: {
        feedbackTitle: 'Электронное обращение',
        rools: 'Правила пользования почтой и т.д.',
        roolsAcceptMessage: 'Я согласен с правилами',
        enterEmail: 'Введите ваш email',
        chooseTopic: 'Выберите тему',
        enterMessage: 'Введите текст сообщения',
        send: 'отправить',
        admin: 'Для администратора',
        denis: 'Для Дениса',
        edit: 'Для редактора тестов',
        errorMessage: 'Во время отправки вашего сообщения произошла ошибка. Сообщение не отправлено',
        alertMessage: 'Ваше сообщение успешно отправлено!',
        addMessage: 'Добавление успешно выполнилось!',
        address: 'Адрес',
        street: 'ул. Казинца 4',

        city: 'г.Минск',
        number: 'Телефон',
        addFile: 'Добавить файл'
    },
    authorization: {
        mainText: 'НАЦИОНАЛЬНОЕ ИССЛЕДОВАНИЕ КАЧЕСТВА ОБРАЗОВАНИЯ (НИКО)',
        authorizationTitle: 'Авторизация',
        enterLogin: 'Введите логин',
        enterPassword: 'Введите пароль',
        button: 'Войти',
        passErr:'Неверный логин' ,
        logErr: 'Неверный пароль',

    },
    demotest: {
        title: 'Тест 1',
        questionOne: 'Что бережет копейка? Рубль; Евро; Доллар.',
        questionTwo: 'Монеты какого номинала используются в Республике Беларусь? 10 рублей; 1 рубль ; 2 рубля; 5 рублей.',
        questionThree: 'Вы нашли чемодан с деньгами. Ваши действия?',
        questionFour: 'Мама дала Ване 10 рублей, а папа еще 20% от количества, которое дала мама. Сколько денег дали родители Ване?',
        previousQuestion: 'Предыдущий вопрос',
        nextQuestion: 'Следующий вопрос',
        completeTest: 'Завершить тест',
        messegeAfterFinishedTest: 'Ответ успешно отправлен',
    },
    RoleIdOne: {//admin
        buttonStartTesting: 'Начать тестирование',
        buttonStatistics: 'Статистика',
        subordinates: 'Подчиненные',
        addNewOrganization: 'Добавить новую организацию',
        enterName:'Введите название',
        importButton: 'Импорт',
        message:'Сообщения',
        showAllPost:'Показать все сообщения',
        headerNew: 'Личный кабинет',
        headerMenuExit: 'Выйти',
        additionalInformation:'Доп. информация',
        AddFieldsToFill:'Добавьте поля для заполнения через дробь (" / ")',
        enter:'Введите',
        buttonAdd:'Добавить',
        edit:'Редактировать',
        buttonStart:'Запустить',
        buttonEnd:'Остановить',
        tests:'Тесты',
        clearDatabase:'Очистить базу данных',
        buttonYes:'Да',
        buttonNo:'Нет',
        delete:'Удалить',
        update:'Изменить',
        selectRole:'Выберите роль',
        curator:'Координатор районный/региональный',
        teacher:'Организатор НИКО в учереждении образования',
        expert:'Эксперт',
        editor:'Редактор',
        addNewSubordinate:'Добавьте нового подчиненного',
        FIO:'ФИО',
        login:'Логин',
        loginExample:'Пример логина',
        import:'Импорт',
        class:'класс',
        send:'Отправить',
        instructions:'Инструкции',
        start:'Запуск',
        demo:'Демо',
        checking:'На проверку',
    },
    RoleIdTwo: {// teacher
        titleName: 'Учитель 1',
        students: 'Учащиеся',
        buttonStatistics: 'Статистика',
        importButton: 'Импорт',
        edit:'Редактировать',
        add:'Добавить',
        enter:'Введите',
        delete:'Удалить',
        buttonYes:'Да',
        buttonNo:'Нет',
        change:'Изменить',
        FIO:'ФИО',
        login:'Логин',
        class:'класс/курс',
        AddNewStudent:'Добавьте нового учащегося',
        settings:'Настройки',
    },

    RoleIdThree: {// creator
        title: 'Выберите необходимое',
        questionnaireButton: 'Анкеты',
        createTestButton: 'Создать тест/анкету',
        createQuestionButton: 'Создать вопрос',
        createTextButton: 'Создать текст',
        createTaskButton: 'Создать задание',
        createFilterManagementButton: 'Управление фильтрами',
        followingTests: 'Доступны следующие тесты:',
        addTestButton: 'Добавить новый тест',
        createTestDiscipline: 'Дисциплина',
        createTestComplexity: 'Сложность',
        createTestButtonFind: 'Найти',
        createTestNameOfTheTest: 'Название ',
        createTestDescriptionTest: 'Описание',
        createTestQuestionnaire: 'Анкета',
        createTestTest: 'Тест',
        createTestCompletionTime: 'Время прохождения (в минутах)',
        howManyPoint: 'Сколько баллов за вопрос',
        createTestQuestionsTest: 'Вопросы теста',
        sendButton: 'Отправить',
        createTaskTitle: 'Конструктор вопроса',
        createTaskСhangeToTheComplexTaskConstructor: 'изменить на конструктор комплексного задания',
        createTextConstructor:'Конструктор текстов',
        createTaskCreateQuestion: 'Создание вопроса',
        createTaskClear: 'очистить',
        createTaskMakeQuestion: 'Создать вопрос',
        createTaskType: 'Тип',
        createTaskQuestion: 'Вопрос',
        createTaskQuestionText: 'Текст вопроса',
        createTaskTheQuestionText: 'текст условия',
        createTaskButtonAddResponseOption: 'Добавить вариант ответа',
        createTaskButtonDeleteAnswerOption: 'Удалить вариант ответа',
        createTaskAnswers: 'Ответы',
        answer:'ответ',
        textAnswer:'Текст ответа',
        createTaskTypeText: 'Текст',
        createTaskTags: 'Тэги',
        createTaskButtonDiscipline: 'Дисциплина',
        createTaskButtonComplexity: 'Сложность',
        createTaskExplanation: 'Пояснение',
        createTaskTextOfTheExplanationToTheAnswers: 'Текст пояснения для ответов',
        createTasksendButton: 'Отправить',
        createTextSendButton: 'Отправить текст',
        updateTextSendButton: 'Редактировать текст',
        createTaskComplexTaskConstructor: 'Конструктор комплексного задания',
        createTaskButtonChangeToTaskConstructor: 'Изменить на конструктор задания',
        createTaskGeneralCondition: 'Общее условие',
        createTaskButtonSelectQuestion: 'Выбрать вопрос',
        createTaskButtonCreateQuestion: 'Создать вопрос',
        createTaskButtonSave: 'Сохранить комплексное задание',
        blockTest:'Блоки теста',
        questions:'Вопросы',
        texts:'Тексты',
        TextsForAComplexTask:'Тексты к комплексному заданию',
        questionsOfAComplexTask:'Вопросы комплексного задания',
        filterCreateCategory: 'Cоздать категорию',
        chooseTypeQuestion:'Выберете тип вопроса',
        choiceOfOneOption:'Выбор одного варианта',
        multipleChoice:'Выбор нескольких вариантов',
        longAnswer:'Длинный ответ',
        shortAnswer:'Короткий ответ',
        associations:'Ассоциации',
        omissionsInTheText:'Пропуски в тексте',
        sequencing:'Составление последовательности',
        withExplanation:'С пояснением',
        transfer:'Перетаскивание',
        table:'Таблица',
        variety:'С вариативностью',
        addLine:'Добавить строку',
        addColumn:'Добавить столбец',
        addFile: 'Добавить файл',
        addFileText:`Чтобы добавить файл
нажмите на кнопку
добавить файл
или перетщите нужный файл
в выделеную область`,
        parameters:'Параметры',
        width:'ширина',
        height:'высота',
        wrapping:'Обтекание текстом'
    },
    RoleIdFour: {//student
        resault: 'Результат',
        points:'Баллов',
        notCorrectAnswers:'Не правильных ответов',
        correctAnswers:'Правильных ответов',
        edit:'Редактировать',
        explanation:'Пояснение',
        yourAnswer:'Ваш ответ',
        correctAnswer:'правильный ответ',
        availableForPassage: 'Доступные для прохождения',
        textForAvailableTest: 'Нет доступных тестов',
        textForAvailableAnket: ' Нет доступных анкет',
        NoTestsPassed:'Нет пройденых тестов'

    },
    RoleIdFive: {// куратор
        subordinates: 'Починенные области',
        buttonEdit: 'Редактировать',
        buttonSubmit:'Добавить',
        textSubmit:'Добавить нового подчиненного',
        fullNameText: 'ФИО',
        fullNameTextEnter: 'Введите Фамилию, Имя, Отчество',
        login:'Логин',
        loginEnter:'Введите логин',
        password:'Пароль',
        passwordEnter:'Введите пароль',
        selectButton:'Выберете из списка',
        addButton:'Добавить',
    },
    RoleIdSix: {//expert
        questions:'Вопросы',
        question:'Вопрос',
        studentAnswer:'Ответ обучающегося',
        maxScore:'Максимальный балл',
        score:'Балл',
        send:'Отправить',
        enterNumberScore:'Введите количество баллов',
        underReview:'На проверке',
        verified:'Проверенные',
    },
    error:{
       errReturn: 'Вернуться на главную страницу',
       notFound: 'Страница не найдена',
    },
    footer: {
       number: 'телефон для справок: +375 25 000-0-00',
       mail: ' почта: krisevich@giac.by',
       text: '©2020-2022 - Министерство образования Республики Беларусь, ГИАЦ Минобразования',
    },
    instructions: {
       next:'Дальше',
    }
}
